import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../assets/styles/styles.scss";
import Metadata from "../../components/Metadata";
import Header from "../../components/dashboard/Header";
import Menu from "../../components/dashboard/Menu";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { Spin, Card, Steps, Image, Tag, Button } from "antd";
import { orderSteps, formatDateFr, isImage } from "../../config/helpers";

const { Step } = Steps;

export default function OrderDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchOrder() {
      setLoading(true);
      const orderDoc = await getDoc(doc(db, "medicationOrders", id));
      if (orderDoc.exists()) {
        const data = orderDoc.data();

        let patient = { firstName: "_", lastName: "_", email: "_", avatar: null };
        if (data.patientId) {
          const patientDoc = await getDoc(doc(db, "medicationUsers", data.patientId));
          if (patientDoc.exists()) patient = patientDoc.data();
        }

        let driver = { firstName: "_", lastName: "_", email: "_", avatar: null };
        if (data.driverId) {
          const driverDoc = await getDoc(doc(db, "medicationUsers", data.driverId));
          if (driverDoc.exists()) driver = driverDoc.data();
        }

        setOrder({ ...data, patient, driver });
      }
      setLoading(false);
    }

    fetchOrder();
  }, [id]);

  if (loading || !order) return <Spin tip="Chargement..." size="large" />;

  return (
    <>
      <h2 className="dashboard-title" style={{ marginBottom: 30 }}>
        Détails de la commande
      </h2>

      <Card
        title={`Commande #${order.number}`}
        style={{ marginBottom: 20 }}
        bordered={false}
        bodyStyle={{ padding: 20 }}
      >
        <p><strong>Client:</strong> {order.patient.firstName} {order.patient.lastName}</p>
        <p><strong>Email:</strong> {order.patient.email}</p>
        <p><strong>Date:</strong> {order.createdAt?.toDate ? order.createdAt.toDate().toLocaleString() : "—"}</p>
        <p><strong>Adresse de livraison:</strong> {order.deliveryAdress?.details}</p>
      </Card>

      <Card title="Ordonnance" style={{ marginBottom: 20 }} bodyStyle={{ padding: 20 }}>
        <Image
          src={isImage(order.prescription.type) ? order.prescription.fileUrl : "/assets/images/document.png"}
          alt="Ordonnance"
          style={{ maxHeight: 300, objectFit: "contain" }}
        />
      </Card>

      <Card title="Suivi de la commande" style={{ marginBottom: 20 }} bodyStyle={{ padding: 20 }}>
        <Steps direction="vertical" current={order.currentStep}>
          {orderSteps.map((step, idx) => (
            <Step
              key={idx}
              title={step.label}
              status={idx < order.currentStep ? "finish" : idx === order.currentStep ? "process" : "wait"}
            />
          ))}
        </Steps>
      </Card>

      {order.driver && (
        <Card title="Livreur" style={{ marginBottom: 20 }} bodyStyle={{ padding: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
            <Image
              width={60}
              height={60}
              src={order.driver.avatar || "/assets/images/avatar-placeholder.png"}
              style={{ borderRadius: "50%" }}
            />
            <div>
              <p style={{ margin: 0 }}>{order.driver.firstName} {order.driver.lastName}</p>
              <p style={{ margin: 0, fontSize: 12, color: "#666" }}>{order.driver.email}</p>
            </div>
          </div>
        </Card>
      )}

      <div style={{ display: "flex", gap: 10 }}>
        <Button type="default" style={{ color: "#FF2222", borderColor: "#FF2222" }} onClick={() => navigate("/admin/public-app-orders")}>
          Retour à la liste
        </Button>
        {/*<Button type="default" style={{ color: "#FF2222", borderColor: "#FF2222" }} onClick={() => window.print()}>
          Imprimer
        </Button>*/}
      </div>
    </>
  );
}
